import {Button} from "@luciad/ria-sample-common/components/button/Button";
import React from "react";
import {useState} from "react";

interface Props {
  label: string;
  modal: (show: boolean, onHide: () => void) => JSX.Element;
}

export const ButtonWithModal = ({label, modal}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const showModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
      <>
        <Button onClick={showModal}>{label}</Button>
        {modal(modalOpen, closeModal)}
      </>
  );
}